(function () {
    'use strict';

    function encodeUriComponent($window) {
        return function (value) {
            return $window.encodeURIComponent(value);
        };
    }

    encodeUriComponent.$inject = ['$window'];

    angular.module('ecap.common').filter('encodeUriComponent', encodeUriComponent);
})();